var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import TinyMCE from 'components/shared/TinyMCE/component';
import { adminCreateCompanyAction, adminRemoveCompanyAction, adminUpdateCompanyAction } from '../../../../../../../redux/actions/admin/admin.company.actions';
CompanyForm.propTypes = {
    company: PropTypes.object,
    onModalClose: PropTypes.func.isRequired
};
export default function CompanyForm(_a) {
    var _b;
    var company = _a.company, onModalClose = _a.onModalClose;
    var dispatch = useDispatch();
    var templateId = useSelector(function (state) { return state.admin.singleTemplate._id; });
    var title = company ? company.name[0].value : '';
    var isCompanyBank = (_b = company === null || company === void 0 ? void 0 : company.isBank) !== null && _b !== void 0 ? _b : false;
    var isCompanyVisible = company ? company.visibility : true;
    var _c = useState(getDescription(company)), editorText = _c[0], setEditorText = _c[1];
    var _d = useState(isCompanyBank), isBank = _d[0], setIsBank = _d[1];
    var _e = useState(isCompanyVisible), isVisible = _e[0], setIsVisible = _e[1];
    var onFormSubmit = function (e) {
        e.preventDefault();
        var target = e.target;
        company ? stageUpdateHandler(target) : stageCreationHandler(target);
        onModalClose();
    };
    function stageCreationHandler(target) {
        dispatch(adminCreateCompanyAction({
            template_id: templateId,
            balance: Number(target.balance.value),
            name: target.name.value,
            description: editorText,
            isBank: isBank,
            visibility: isVisible
        }));
    }
    function stageUpdateHandler(target) {
        dispatch(adminUpdateCompanyAction(company._id, {
            template_id: templateId,
            balance: Number(target.balance.value),
            name: __assign(__assign({}, company.name[0]), { value: target.name.value }),
            description: __assign(__assign({}, company.description[0]), { value: editorText }),
            isBank: isBank,
            visibility: isVisible
        }));
    }
    return (React.createElement("form", { onSubmit: onFormSubmit, className: "text-align-left admin-form" },
        React.createElement("div", { className: "mar-top-5 admin-form__area" },
            React.createElement("span", null, "Firma nimi:"),
            React.createElement("input", { type: "text", name: "name", defaultValue: title })),
        React.createElement("div", { className: "mar-top-5 admin-form__area" },
            React.createElement("span", null, "Algusraha:"),
            React.createElement("input", { type: "number", name: "balance", defaultValue: company ? company.balance : 1000 })),
        React.createElement("div", { className: "mar-top-5 admin-form__area" },
            React.createElement("span", null, "Bank?:"),
            React.createElement("input", { type: "checkbox", name: "bank", defaultChecked: isBank, onChange: function () { return setIsBank(!isBank); } })),
        React.createElement("div", { className: "mar-top-5 admin-form__area" },
            React.createElement("span", null, "N\u00E4htav?:"),
            React.createElement("input", { type: "checkbox", name: "visibility", defaultChecked: isVisible, onChange: function () { return setIsVisible(!isVisible); } })),
        React.createElement("div", { className: "mar-top-5" },
            React.createElement(TinyMCE, { value: editorText || null, onChange: function (value) { return setEditorText(value); } })),
        React.createElement("div", { className: "mar-top-20 text-align-center flex-justify-content-center d-flex flex-gap-10" },
            React.createElement("button", { className: "main-button main-button--error", type: "button", onClick: onModalClose }, "close"),
            React.createElement("button", { className: "main-button", type: "submit" }, "Save"))));
}
function getDescription(stage) {
    if (!stage)
        return '';
    var description = stage.description;
    if (Array.isArray(description) && description.length)
        return description[0].value;
    return description;
}
